export default {
  buyer_create_question: {
    management: {
      // create_new: '',
      // create_new_start: '',
      // create_new_start_description: '',
      // create_by_template: '',
      // create_by_template_description: '',
      // created_survey_list_title: '',
      // survey: '',
      // number_of_survey: '',
    },
    list: {
      number_of_answered_company: '@:evaluation_dashboard.answer_transition.companies_submitted',
      // no_survey: '',
    },
    flow: {
      // title: '',
      // basic: '',
      // basic_description: '',
      // create_description: '',
      // confirm_description: '',
      // issue_url: '',
      // issue_url_description: '',
    },
    // language: '',
    // language_description: '',
    // base_language: '',
    // add_language: '',
    // caution: '',
    // survey_title: '',
    // survey_title_description: '',
    // answer_deadline_description: '',
    // number_of_target_company: '',
    // number_of_target_company_description_1: '',
    // number_of_target_company_description_2: '',
    btn: {
      // save_and_exit: '',
      // preview: '',
      // back_edit: '',
      // start_survey: '',
      // copy_url: '',
    },
    create: {
      // back_settings: '',
      // bundle: '',
      question: '@:list_table_filter.csv_modal_answer_heading_question',
      // structure: '',
      // error_alert: '',
      // question_text: '',
      // required_type: '',
      // guide: '',
      // answer_type: '',
      // single_select: '',
      // multiple_selects: '',
      // text: '',
      // number: '',
      // amount: '',
      // selects: '',
      // selects_add: '',
      // selects_branch: '',
      // selects_add_description: '',
      // remarks: '',
      // attach: '',
      // copy_question: '',
    },
    start_survey_modal: {
      // title: '',
      // description_1: '',
      // description_2: '',
    },
    // registration_url: '',
    // registration_url_description_1: '',
    // registration_url_description_2: '',
    // registration_default_language: '',
  },
};